import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {HttpClient} from "@angular/common/http";
import {EventsService} from "app/lib/EventsService";
import {BaseComponent} from "app/views/base.component";
import {HelperService} from "app/lib/helper.service";
import {FilterParams} from "../../models/filter_form.model";
import {ChartParams} from "../../views/chart/chart.component";
import {ModalService} from "../../views/modal/base_modal.component";
import {AlertComponent} from "../../views/modal/alert.component";
import {SiteCategoryDetailsComponent} from "./details/site_category_details.component";
import { SitesService } from "../../sites/sites.service";
import { IStatResult } from "../../models/responce_result.model";

interface ISiteCategoriesStats extends IStatResult {
	values: number[];
	categories: string[];
	totalCount: number;
}

interface ISiteCategoriesDetail extends IStatResult {
	totalCount: number;
}

@Component({
	selector: 'site-categories',
	templateUrl: './site_categories.component.html'
})
export class SiteCategoriesComponent extends BaseComponent {
	addFilterParams = {
		userType: 'user',
		isTemplateTag: true,
		dateFilters : ['dateCreated', 'dateSiteCreated', 'datePaid', 'dateAccessorView']
	};

	reportType: string = 'categories';
	
	chartType: string = 'Category';
	
	categoryId: string = '';
	subjectId: string = '';
	
	values = [];
	categories = [];
	totalCount: number = 0;

	categoryLoader: boolean = false;

	categoryChart = new ChartParams();

	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public filter: FilterFormService,
		public modalService: ModalService,
		public http: HttpClient,
		public helper: HelperService,
		public siteService: SitesService,
	) {
		super(eventsService, siteService, activatedRoute, filter, translate);
	}

	async getData() {
		await this.getStats('', this.reportType);
	}
	
	
	async getStats(categoryId: string, reportType: string) {
		let me = this;
		
		me.reportType = reportType;

		me.chartType  = categoryId !== '' ? 'Subject' : 'Category';
		me.categoryId = categoryId;
		me.subjectId  = '';

		me.categoryLoader = true;
		
		const fp = me.reportType === 'categories' ? me.filter.getCopyFilterParams(
			<FilterParams>{ categoryId: me.categoryId, subjectId: me.subjectId }
		) : me.filter.filterParams;

		const { values, categories, totalCount } = await me.siteService.siteCategories.stats<ISiteCategoriesStats>(fp).toPromise();

		me.categoryChart.setOptions({
			title: me.categoryId !== '' ? me.categoryId : me.translate.__A('template.show ' + me.reportType),
			onclick: async function(e) {
				if (me.reportType === 'subjects') return true;
				
				if (me.chartType === 'Category') {
					await me.getStats(categories[e.x], 'categories');
				} else if (me.chartType === 'Subject') {
					await me.getDetails(categories[e.x]);
				}
			},
			type : 'bar',
			
			
			padding: {
				top: 10,
				bottom: 0
			},
			size: {
				height: me.reportType === 'categories' ? 650 : 4000
			},
			axis: {
				rotated: true,
				x: {
					type: 'category',
					categories: categories,
					tick: {
						multiline: false
					}
				}
			}
		});

		me.categoryChart.data = [values];

		me.values     = values;
		me.categories = categories;
		me.totalCount = totalCount;

		me.categoryLoader = false;
	}
	
	
	async getDetails(subjectId: string) {
		this.subjectId = subjectId;

		const { totalCount, stats, } = await this.siteService.siteCategories.detail<ISiteCategoriesDetail>(
			this.filter.getCopyFilterParams(
				<FilterParams>{ categoryId: this.categoryId, subjectId: this.subjectId, page: 1 }
			)
		).toPromise();
		
		const modalRef = this.modalService.open(SiteCategoryDetailsComponent, {
			title: `${this.categoryId} - ${this.subjectId}`,
			totalCount: totalCount,
			categoryId: this.categoryId,
			subjectId: this.subjectId,
			params: this.filter.filterParams
		}, {size: 'hg'});
		
		modalRef.componentInstance.details = stats
	}
	
	
	async downloadButton() {
		window.location.href = this.siteService.siteCategories.downloadFileRoute(
			this.filter.getCopyFilterParams(
				<FilterParams>{ categoryId: this.categoryId, subjectId: this.subjectId }
			),
			this.reportType === 'categories' ? 'download_abs' : 'download_sub_abs'
		);

		this.modalService.open(AlertComponent, {
			title: 'INFO',
			message: this.translate.__A('common.download file')
		});
	}
}
